function state() {
  return {
    dataPartner: {},
    editProductCategory: {},
    isComingFromCreatePartner: false,
    listProductCategoriesByOrganization: [],
    partnerProducts: [],
  };
}

export default state;
